export function TruncatePrice(price: number) {
	if (!!price) {
		return (Math.floor(price * 100) / 100).toFixed(2);
	} else {
		return '0.00';
	}
}